<template>
    <div class="rich-text-deitor">
        <div class="editor-title">
            <div class="text">
                <icon-svg data_iconName="text" className="img_icon" />
                <i>文字</i>
            </div>
        </div>
        <div class="editor-content">
            <textarea
                v-model="queryInfo.content"
                class="editor-reply"
                placeholder="请输入内容"
            ></textarea>
        </div>
        <el-button type="primary" @click="saveReply">保存</el-button>
        <el-popover placement="top" v-model="deleteVisible" class="pop-confirm">
            <p>这是一段内容这是一段内容确定删除吗？</p>
            <div style="text-align: right; margin: 0">
                <el-button
                    size="mini"
                    type="text"
                    @click="deleteVisible = false"
                    >取消</el-button
                >
                <el-button type="primary" size="mini" @click="deleteReply"
                    >确定</el-button
                >
            </div>
            <el-button slot="reference">删除回复</el-button>
        </el-popover>
    </div>
</template>

<script>
// 引入 wangEditor
// import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
    props: ["type"],
    data() {
        return {
            dialogVisible: false,
            queryInfo: {
                id: null,
                content: "",
                msgType: "text",
            },
            // 删除确认框的显示与隐藏
            deleteVisible: false,
        };
    },
    created() {
        this.getInfoDetail(this.type);
    },
    methods: {
        // 保存回复
        saveReply() {
            this.queryInfo.type = this.type;
            this.$ajaxPost("/wxMsg/update/open", this.queryInfo).then(
                ({ data }) => {
                    if (data.code === 0)
                        return this.$message.success("保存成功");
                }
            );
        },
        // 删除收到消息回复
        deleteReply() {
            this.queryInfo.type = this.type;
            this.queryInfo.content = "";
            this.$ajaxPost("/wxMsg/update/open", this.queryInfo).then(
                ({ data }) => {
                    if (data.code === 0) {
                        this.deleteVisible = false;
                        this.editor.txt.clear();
                        this.$message.success("删除成功");
                    }
                }
            );
        },
        // 获取已有消息的详细信息
        getInfoDetail(type) {
            this.$ajaxGet("/wxMsg/list/open", {
                page: 1,
                limit: 1,
                type,
            }).then(({ data }) => {
                if (data.code === 0) {
                    const { list } = data.data;
                    this.queryInfo.id = list[0].id;
                    this.queryInfo.content = list[0].content;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
@blueColor: #409eff;
.editor-title {
    display: flex;
    height: 50px;
    line-height: 50px;
    border: 1px solid #c9d8db;
    border-bottom: none;
    .text,
    .img {
        width: 100px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        i {
            margin-left: 5px;
            font-style: normal;
        }
    }
    .active {
        color: @blueColor;
    }
}

.editor-content {
    padding: 20px;
    height: 302px;
    margin-bottom: 10px;
    width: 100%;
    border: 1px solid #c9d8db;
    box-sizing: border-box;
}

.emojies-list {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    li {
        margin-left: 10px;
        margin-top: 10px;
    }
}
.pop-confirm {
    margin-left: 10px;
}
.editor-reply {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
}
</style>